webpackJsonpUpdateBris([99],{

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.BrandNavigation = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(4);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// CONSTANTS are all caps.
var NS = 'BrandNavigation';
var CLS = 'brandNavigation';
var BLK = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

var BrandNavigation = exports.BrandNavigation = function () {
	function BrandNavigation($el) {
		_classCallCheck(this, BrandNavigation);

		// $el is the blk node return by the loadBrandNavigation function
		this.$el = $el;
	}

	_createClass(BrandNavigation, [{
		key: 'init',
		value: function init() {
			this.setBrandNavigation();
		}
	}, {
		key: 'setBrandNavigation',
		value: function setBrandNavigation() {
			// Add Some logic here
			var $this = $(this.$el);
			var $navItem = $this.find(BLK + 'navItem');
			var indexActive = $this.find(BLK + 'navItem.active').index();

			function showSubmenu(element) {
				if (element.hasClass('has-dropdown')) {
					element.find('.dropdown-menu').css('display', 'block');
					element.find('.dropdown-menu li').animate({
						opacity: '1'
					}, 0);
				}
			}
			function hideSubmenu(element) {
				element.find('.dropdown-menu').css('display', 'none');
				element.find('.dropdown-menu li').css('opacity', '0');
			}
			$navItem.on('click', function (e) {
				$navItem.removeClass('active');
				$(this).addClass('active');
				hideSubmenu($navItem);
				showSubmenu($(this));
				indexActive = $(this).index();
			});
			$navItem.hover(function () {
				if (!utils.isOnMobile()) {
					$navItem.removeClass('active');
					hideSubmenu($navItem);
					$(this).addClass('active');
					showSubmenu($(this));
				}
			}, function () {
				if (!utils.isOnMobile()) {
					$(this).removeClass('active');
					hideSubmenu($(this));
					$navItem.eq(indexActive).addClass('active');
					showSubmenu($navItem.eq(indexActive));
				}
			});

			$this.on('mouseleave', '.' + CLS + '-navList', function () {
				if (!utils.isOnMobile()) {
					$this.find('.dropdown-menu').css('display', 'none');
					$this.find('.' + CLS + '-navItem.active').removeClass('active');
				}
			});
		}

		// Add more functions like on above here

	}]);

	return BrandNavigation;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })

});


// WEBPACK FOOTER //
// 1754042353042.blk-brand-navigation-chunk.js